import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CheckerboardBackground = styled(Stack)(() => ({
  "--size": "32px",
  "--white": "rgba(50, 50, 50, 0.1)",
  "--black": "rgba(0, 0, 0, 0.1)",

  backgroundImage: `
      repeating-conic-gradient(
        var(--black) 0% 25%,
        var(--white) 0% 50%
      )
    `,
  backgroundSize: "var(--size) var(--size)",
  backgroundRepeat: "repeat",
}));
